import { Injectable, inject, effect } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '@services/core/auth.service';
import { StorageService } from '@services/core/storage.service';

@Injectable({ providedIn: 'root' })
export class RouteGuard implements CanActivate {
  private authService = inject(AuthService);
  private storageService = inject(StorageService);
  private router = inject(Router);



  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const urlParams = this.urlToMenu(state.url);
    let menu = this.storageService.getJsonValue('menu');
    const canAccess = this.verifyRoute(urlParams, menu);

    if (!canAccess) {
      this.router.navigate(['']);
      return false;
    }

    return true;
  }
  private urlToMenu(url: string): string {
    let urlParams = url.split('?')[0];
    if (urlParams.startsWith('/')) {
      urlParams = urlParams.substring(1);
    }
    return urlParams;
  }

  private isRouteAllowed(url, item) {
    const routeItem = this.getRouteFromItem(item);
    const urlLower = url.toLowerCase();

    if (this.isExactMatch(routeItem, urlLower)) {
      return true;
    }

    if (this.isPartialMatch(routeItem, urlLower)) {
      return true;
    }

    if (this.hasSubmenuMatch(item, url)) {
      return true;
    }

    return false;
  }

  private verifyRoute(url: string, menu: any[]): boolean {
    return menu.some(item => this.isRouteAllowed(url, item));
  }

    private getRouteFromItem(item: any): string {
        return (item.url ?? item.path ?? '').toLowerCase();
    }

  private isExactMatch(routeItem: string, urlLower: string): boolean {
    const isMatch = routeItem === urlLower;
    return isMatch;
  }

  private isPartialMatch(routeItem: string, urlLower: string): boolean {
    return routeItem && urlLower.startsWith(routeItem + '/');
  }

  private hasSubmenuMatch(item, url) {
    if (item.submenu && Array.isArray(item.submenu)) {
      return this.verifyRoute(url, item.submenu);
    }
    return false;
  }
}